import { SendAnnouncementQueryArg } from '../types/query-arg';
import { SendAnnouncementQueryBody } from '../types/query-body';

export const SendAnnouncementQueryArgBody = ({
  unitIds,
  notificationText,
  notificationType,
}: SendAnnouncementQueryArg): SendAnnouncementQueryBody => ({
  notificationType: notificationType,
  unitIds: unitIds,
  notificationText: notificationText,
});
